/**
 * @generated SignedSource<<bf0dbe606ff92a7fe8d53e69ed237e99>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CryptoTransfersTransactionRequiredActions = "BENEFICIARY_DETAILS";
export type CryptoTransfersTransactionStatus = "CANCELED" | "FINISHED" | "NOT_CONFIRMED" | "ON_HOLD" | "PENDING" | "PROCESSING" | "REFUNDED" | "REJECTED";
export type CryptoTransfersTransactionType = "DEPOSIT" | "WITHDRAWAL";
export type InitiatedBy = "BITPANDA_CORPORATE_ACTION" | "BITPANDA_MANUAL_TRADE" | "BITPANDA_SAVINGS" | "BITPANDA_SWAPS" | "ORDER" | "OTHER" | "USER";
export type TaxDeclarationStatus = "DECLARED" | "NOT_ELIGIBLE" | "UNDECLARED" | "UNKNOWN";
export type TransactionCategory = "CORPORATE_ACTION" | "CRYPTO_ACTION" | "CRYPTO_TRANSFER" | "FIAT_TRANSFER" | "NON_USER_INITIATED" | "STAKING" | "TRADE";
export type TransactionDirection = "INCOMING" | "OUTGOING";
export type TransactionStatus = "CANCELED" | "CREATED" | "CREDITED" | "EXPIRED" | "FAILED" | "FINISHED" | "IN_PROGRESS" | "REFUNDED" | "REJECTED";
export type TransactionType = "BUY" | "SELL";
export type CryptoTransfersTransactionsListInput = {
  assetId?: string | null | undefined;
  coinNetworkId?: string | null | undefined;
  cursor?: string | null | undefined;
  dateEnd?: TimeScalar | null | undefined;
  dateStart?: TimeScalar | null | undefined;
  id?: string | null | undefined;
  size?: number | null | undefined;
  status?: ReadonlyArray<CryptoTransfersTransactionStatus> | null | undefined;
  type?: CryptoTransfersTransactionType | null | undefined;
};
export type TransactionsListInput = {
  after?: string | null | undefined;
  assetId?: string | null | undefined;
  before?: string | null | undefined;
  category?: TransactionCategory | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  type?: TransactionType | null | undefined;
};
export type TransactionsViewWithCryptoTransfersQuery$variables = {
  cryptoTransfersInput?: CryptoTransfersTransactionsListInput | null | undefined;
  input?: TransactionsListInput | null | undefined;
};
export type TransactionsViewWithCryptoTransfersQuery$data = {
  readonly cryptoTransfersTransactions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly asset: {
          readonly __typename: string;
          readonly id: string;
          readonly logoUrl: string | null | undefined;
          readonly name: string | null | undefined;
          readonly symbol: string | null | undefined;
        };
        readonly assetAmount: PrecisionFloat;
        readonly assetFee: PrecisionFloat;
        readonly createdAt: TimeScalar | null | undefined;
        readonly externalAddress: {
          readonly address: string;
          readonly createdAt: TimeScalar | null | undefined;
          readonly destinationTag: string | null | undefined;
          readonly destinationTagType: string | null | undefined;
          readonly id: string;
          readonly network: {
            readonly id: string;
            readonly name: string | null | undefined;
          };
        } | null | undefined;
        readonly fiat: {
          readonly id: string;
          readonly name: string | null | undefined;
          readonly symbol: string | null | undefined;
        };
        readonly fiatAmount: PrecisionFloat;
        readonly fiatFee: PrecisionFloat;
        readonly hash: string | null | undefined;
        readonly id: string;
        readonly internalAddress: {
          readonly address: string;
          readonly createdAt: TimeScalar | null | undefined;
          readonly destinationTag: string | null | undefined;
          readonly destinationTagType: string | null | undefined;
          readonly id: string;
          readonly network: {
            readonly id: string;
            readonly name: string | null | undefined;
          };
        } | null | undefined;
        readonly network: {
          readonly id: string;
          readonly name: string | null | undefined;
        };
        readonly parentId: string;
        readonly requiredActions: ReadonlyArray<CryptoTransfersTransactionRequiredActions | null | undefined> | null | undefined;
        readonly status: CryptoTransfersTransactionStatus;
        readonly taxDeclarationStatus: TaxDeclarationStatus | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly transactions: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly __typename: string;
        readonly asset: {
          readonly __typename: string;
          readonly id: string;
          readonly logoUrl: string | null | undefined;
          readonly name: string | null | undefined;
          readonly symbol: string | null | undefined;
        } | null | undefined;
        readonly assetAmount: PrecisionFloat | null | undefined;
        readonly assetPrice?: PrecisionFloat | null | undefined;
        readonly category: TransactionCategory;
        readonly direction: TransactionDirection | null | undefined;
        readonly fiatAmount: PrecisionFloat | null | undefined;
        readonly id: string;
        readonly initiatedBy: InitiatedBy | null | undefined;
        readonly offer?: {
          readonly id: string;
        } | null | undefined;
        readonly parentId: string;
        readonly status: TransactionStatus | null | undefined;
        readonly time: TimeScalar | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
    };
    readonly totalCount: number | null | undefined;
  } | null | undefined;
};
export type TransactionsViewWithCryptoTransfersQuery = {
  response: TransactionsViewWithCryptoTransfersQuery$data;
  variables: TransactionsViewWithCryptoTransfersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cryptoTransfersInput"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Network",
  "kind": "LinkedField",
  "name": "network",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v7 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "address",
    "storageKey": null
  },
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "destinationTag",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "destinationTagType",
    "storageKey": null
  },
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetAmount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiatAmount",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "assetPrice",
    "storageKey": null
  }
],
v14 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TransactionOffer",
    "kind": "LinkedField",
    "name": "offer",
    "plural": false,
    "selections": [
      (v2/*: any*/)
    ],
    "storageKey": null
  }
],
v15 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "cryptoTransfersInput"
      }
    ],
    "concreteType": "CryptoTransfersTransactionsConnection",
    "kind": "LinkedField",
    "name": "cryptoTransfersTransactions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CryptoTransfersTransactionsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CryptoAddress",
                "kind": "LinkedField",
                "name": "internalAddress",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CryptoAddress",
                "kind": "LinkedField",
                "name": "externalAddress",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v8/*: any*/),
                  (v4/*: any*/),
                  (v9/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "assetFee",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Fiat",
                "kind": "LinkedField",
                "name": "fiat",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fiatFee",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hash",
                "storageKey": null
              },
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requiredActions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taxDeclarationStatus",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TransactionsConnection",
    "kind": "LinkedField",
    "name": "transactions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasNextPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasPreviousPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endCursor",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TransactionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "time",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "category",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "initiatedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "direction",
                "storageKey": null
              },
              (v12/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v4/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v13/*: any*/),
                "type": "BuyTransaction",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v13/*: any*/),
                "type": "SellTransaction",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v14/*: any*/),
                "type": "DepositTransaction",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v14/*: any*/),
                "type": "WithdrawalTransaction",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TransactionsViewWithCryptoTransfersQuery",
    "selections": (v15/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TransactionsViewWithCryptoTransfersQuery",
    "selections": (v15/*: any*/)
  },
  "params": {
    "cacheID": "4d81d2253796c2aa2e3860648d83bf53",
    "id": null,
    "metadata": {},
    "name": "TransactionsViewWithCryptoTransfersQuery",
    "operationKind": "query",
    "text": "query TransactionsViewWithCryptoTransfersQuery(\n  $cryptoTransfersInput: CryptoTransfersTransactionsListInput\n  $input: TransactionsListInput\n) {\n  cryptoTransfersTransactions(input: $cryptoTransfersInput) {\n    edges {\n      node {\n        __typename\n        id\n        parentId\n        internalAddress {\n          id\n          address\n          network {\n            id\n            name\n          }\n          destinationTag\n          destinationTagType\n          createdAt\n        }\n        externalAddress {\n          id\n          address\n          network {\n            id\n            name\n          }\n          destinationTag\n          destinationTagType\n          createdAt\n        }\n        asset {\n          id\n          logoUrl\n          name\n          symbol\n          __typename\n        }\n        assetAmount\n        assetFee\n        fiat {\n          id\n          name\n          symbol\n        }\n        fiatAmount\n        fiatFee\n        network {\n          id\n          name\n        }\n        hash\n        status\n        requiredActions\n        taxDeclarationStatus\n        createdAt\n      }\n    }\n  }\n  transactions(input: $input) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        __typename\n        id\n        parentId\n        time\n        category\n        initiatedBy\n        direction\n        status\n        fiatAmount\n        asset {\n          id\n          logoUrl\n          symbol\n          name\n          __typename\n        }\n        assetAmount\n        ... on BuyTransaction {\n          assetPrice\n        }\n        ... on SellTransaction {\n          assetPrice\n        }\n        ... on DepositTransaction {\n          offer {\n            id\n          }\n        }\n        ... on WithdrawalTransaction {\n          offer {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c78cd788e1f0e0f51fe37704050bad7";

export default node;
